import { render } from "./integrations.vue?vue&type=template&id=d608be0e&scoped=true"
import script from "./integrations.vue?vue&type=script&lang=js"
export * from "./integrations.vue?vue&type=script&lang=js"

import "./integrations.vue?vue&type=style&index=0&id=d608be0e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d608be0e"]])

export default __exports__